<div>
      <div *ngIf="authProvider === 1" class="row" style="padding-top: 12px;">
        <div class="col-md-12">
          <ng-container *ngIf="isLoggedInAD() ; else loggedOutAD">
            <div >
              {{userName}}
              <button class="btn btn-sm btn-outline-primary" (click)="clearCookiesAndLogout();">Log out</button>
              &nbsp;
              <!-- <span>{{userName}}</span> -->
            </div>
          </ng-container>

          <ng-template #loggedOutAD>
            <div>
              <button class="btn btn-sm btn-primary" (click)="loginAD()">Log in</button>
            </div>
          </ng-template>

        </div>
  </div>

</div>
